// export const baseUrl = 'http://localhost:5000';
// export const baseUrl = 'http://pcacad.ddns.net:4321';
//export const baseUrl = 'http://pcacad.ddns.net:4444';
// export const baseUrl = 'http://192.168.1.168:5000';
// export const baseUrl = 'http://192.168.1.194:5000';
// export const baseUrl = 'https://db.buzoo.org';
// export const baseUrl = process.env.REACT_APP_API_URL;
// Production nginx proxies /api/* to the Node backend; local dev talks to the backend directly.
const rawBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';
export const baseUrl = rawBaseUrl.replace(/\/$/, '');